import * as React from 'react';
import { connect } from 'react-redux';
import store from '@/redux/index';
import Editor from 'react-umeditor'
import { types, IExpertEditStoreState } from '@/redux/pages/expert-edit';

const Toast = require('react-toast-mobile');

class ExpertIntroduction extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            text: this.props.introduction || ''
        };
    }
    public render() {
        return (
            <section className="expert-intro">
                <div className="expert-intro-text" >
                    <Editor ref="editor"
                        icons={[]}
                value={this.state.text}
                defaultValue=""
                onChange={this.inputAction.bind(this)}
                />
                </div>
                <div className="expert-intro-btns">
                    <button className="btn-submit" onClick={() => this.submitActioon()}>确定</button>
                </div>
            </section>
        )
    }

    // 自我介绍
    private inputAction(content: any) { 
        this.setState({
            text: content
        });
    }

    // 提交
    private submitActioon() { 
        if (this.state.text === '') {
            return Toast.T.notify('请填写内容');
        } else if (this.state.text.length > 1000) { 
            return Toast.T.notify('内容最多不能超过1000字');
        }
        store.dispatch({
            type: types.INPUT,
            data: {
                key: 'introduction',
                value: this.state.text
            }
        });
        this.props.history.goBack();
    }
}

const mapStateToProps = (state: any): IExpertEditStoreState => { 
    return {
        ...state.expertEditReducers
    }
}

export default connect(mapStateToProps)(ExpertIntroduction);